// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { SetLoading } from '@actions/loading';

type LoadingState = boolean;

type SetLoadingAction = Action<boolean>;

export default handleActions<LoadingState, boolean>(
  {
    [SetLoading.toString()]: (
      _: LoadingState,
      { payload }: SetLoadingAction,
    ): LoadingState => !!payload,
  },
  false,
);
